import { Component, Vue } from 'vue-property-decorator';
import WithRender from './app.html';
// components
import Breadcrumb from '@/components/Breadcrumb/breadcrumb';
// Helpers
import { getThemeColor } from './appTheme';

@WithRender
@Component({
  components: {
    Breadcrumb,
  },
})
export default class App extends Vue {
  mounted() {
    this.updateUIFrameWork();
  }

  public updateUIFrameWork() {
    const { primary, secondary } = this.$vuetify.theme.themes.light;

    const lightTheme = this.$vuetify.theme.themes.light;
    lightTheme.primary = getThemeColor('primary') || primary;
    lightTheme.secondary = getThemeColor('secondary') || secondary;
  }
}
